<template>
   <div class="integration-item setting-item" @click="openModalBox">
      <div class="item-holder">
         <slot name="description"></slot>
         <div class="button-panel">
            <a href="#" class="btn-icon btn-icon-outline btn-rounded btn-icon-transparent editor_trigger">
               <span class="icon icon-settings"></span>
            </a>
         </div>
      </div>
   </div>

   <Teleport to="body">
      <!-- EDITOR WRAPPER-->
      <div class="overlay-editor item-editor" :class="modalBoxTypeClass">
         <div class="overlay-editor-wrapper">

            <div class="panel-top" v-if="!hasTranslate">
               <div class="lang-selector-holder d-flex align-items-center">
               </div>

               <a href="javascript:void(0);" class="back_trigger"
                  @click="$emit('cancelSaveSettingsEvent', this.$props.modalBoxTypeClass)">
                  <span class="icon icon-cross"></span>
               </a>
            </div>
            <div class="panel-top" v-if="hasTranslate">
               <slot name="lang"></slot>
            </div>
            <div class="panel-middle">
               <slot name="content"></slot>
            </div>

            <div class="panel-bottom">
               <button class="transparent-btn default-btn back_trigger"
                  @click="$emit('cancelSaveSettingsEvent', this.$props.modalBoxTypeClass)" :disabled="$props.isLoading">
                  <span class="text">{{ $static('ei.cancel', 'Скасувати') }}</span>
               </button>
               <button class="default-btn btn-accent" @click="$emit('saveSettingsEvent', this.$props.modalBoxTypeClass)"
                  :disabled="$props.isLoading">
                  <span class="text">{{ $static('ei.save', 'Зберегти зміни') }}</span>
               </button>
            </div>
         </div>
      </div>
      <!--END EDITOR WRAPPER-->
   </Teleport>
</template>

<script>
export default {
   props: ["modalBoxTypeClass", "isLoading", "hasTranslate"],
   emits: ["saveSettingsEvent", "cancelSaveSettingsEvent", "settingsInitialized"],

   methods: {
      openModalBox() {
         this.$emit('settingsInitialized');

         window.$('body').addClass('is-hidden');
         window.$('.back-blur').addClass('active');
         window.$("." + this.$props.modalBoxTypeClass).addClass('active');

         window.$('.back-blur').off('click');// удаляем слушатель события клика на бэк-блюр поставленный в AdminBox. Он визуально скрывает модальное окно слишком рано - до момента сохранения данных и/или их обновления.

         window.$('.back-blur').on('click', () => {
            this.$emit('cancelSaveSettingsEvent', this.$props.modalBoxTypeClass)
         })

      }
   }
}
</script>